"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notContainsPredicateGenerator = exports.containsPredicateGenerator = exports.isNotPredicateGenerator = exports.isPredicateGenerator = void 0;
const comparisons_1 = require("../comparisons");
const text_1 = require("../utils/text");
/**
 * Predicate Generator for filtering records by IP address field using IS comparission.
 */
const isPredicateGenerator = (filterValue) => {
    return (0, comparisons_1.isListMultiple)((0, text_1.processMultipleFilterValue)(filterValue));
};
exports.isPredicateGenerator = isPredicateGenerator;
/**
 * Predicate Generator for filtering records by IP address field using IS NOT comparission.
 */
const isNotPredicateGenerator = (filterValue) => {
    return (0, comparisons_1.isNotListMultiple)((0, text_1.processMultipleFilterValue)(filterValue));
};
exports.isNotPredicateGenerator = isNotPredicateGenerator;
/**
 * Predicate Generator for filtering records by IP address field using CONTAINS comparission.
 */
const containsPredicateGenerator = (filterValue) => {
    return (0, comparisons_1.containsList)((0, text_1.processMultipleFilterValue)(filterValue));
};
exports.containsPredicateGenerator = containsPredicateGenerator;
/**
 * Predicate Generator for filtering records by IP address field using NOT CONTAINS comparission.
 */
const notContainsPredicateGenerator = (filterValue) => {
    return (0, comparisons_1.notContainsList)((0, text_1.processMultipleFilterValue)(filterValue));
};
exports.notContainsPredicateGenerator = notContainsPredicateGenerator;
